import * as Types from 'apps/shared/scripts/__generated__/graphql.generated';

import { gql } from '@apollo/client';
export type SignatureFragment = { readonly __typename: 'Signature', readonly timestamp: any, readonly card: { readonly __typename: 'Card', readonly headline: string, readonly id: string, readonly recipientName: string, readonly senderName?: string | null } };

export const SignatureFragmentDoc = gql`
    fragment SignatureFragment on Signature {
  card {
    headline
    id
    recipientName
    senderName
  }
  timestamp
}
    `;